<template>
  <!-- 转库箱子 -->
  <div class="transfer-box-page">
    <baseBreadcrumb :page="$t('message.transferBox')" :menu="$t('message.inventoryTransfer')"></baseBreadcrumb>
    <div class="tabs">
      <!-- 转库箱子状态切换 -->
      <el-tabs v-model="activeTab" type="card" @tab-click="handleTabChange">
        <el-tab-pane v-for="tab in tabs" :key="tab.value" :label="getTabLabel(tab)" :name="tab.status">
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 搜索条件 -->
    <div class="search-area">
      <div class="search-row">
        <!-- 客户ID -->
        <div class="item">
          <el-input v-model="datas.user_id" :placeholder="$t('message.clientID')" clearable />
        </div>
        <!-- 物流号 -->
        <div class="item">
          <el-input v-model="datas.purchase_no" :placeholder="$t('message.logisticsNumber')" clearable />
        </div>
        <!-- 交易号 -->
        <div class="item">
          <el-input v-model="datas.express_no" :placeholder="$t('message.transactionNumber')" clearable />
        </div>
        <!-- 订单号 -->
        <div class="item">
          <el-input v-model="datas.order_sn" :placeholder="$t('message.orderNumber')" clearable />
        </div>
        <!-- 业务员 -->
        <div class="item">
          <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
            <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id" />
          </el-select>
        </div>
        <!-- 采购员 -->
        <div class="item">
          <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
            <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id" />
          </el-select>
        </div>
        <!-- 配货员 -->
        <div class="item">
          <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
            <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id" />
          </el-select>
        </div>
      </div>
      <div class="search-row second">
        <!-- 提出转库开始时间（接口 dateStart） -->
        <div class="item">
          <el-date-picker v-model="datas.pack_date_start" type="datetime" :placeholder="$t('message.packDateStart')"
            value-format="yyyy-MM-dd HH:mm:ss" default-time="00:00:00" />
        </div>
        <!-- 提出转库结束时间（接口 dateEnd） -->
        <div class="item">
          <el-date-picker v-model="datas.pack_date_end" type="datetime" :placeholder="$t('message.packDateEnd')"
            value-format="yyyy-MM-dd HH:mm:ss" default-time="23:59:59" />
        </div>
        <!-- 最小库龄 -->
        <div class="item">
          <el-input v-model="datas.age_min" :placeholder="$t('message.warehouseAgeMin')" clearable />
        </div>
        <!-- 最大库龄 -->
        <div class="item">
          <el-input v-model="datas.age_max" :placeholder="$t('message.warehouseAgeMax')" clearable />
        </div>
        <!-- 搜索和重置 -->
        <div class="search-buttons">
          <el-button type="primary" @click="handleSearch">{{ $t('message.search') }}</el-button>
          <el-button @click="reset">{{ $t('message.reset') }}</el-button>
        </div>
        <!-- 批量操作按钮 -->
        <div class="action-buttons">
          <span class="btn-group" v-if="['1'].includes(activeTab)">
            <!-- 取消转库 -->
            <el-button type="primary" class="btn-dark" @click="transferCancel" v-if="isAuth(736)">{{
              $t('message.cancelTransfer')
            }}</el-button>
            <!-- 确认提交给行政 -->
            <el-button type="primary" class="btn-blue" @click="confirmToAdmin" v-if="isAuth(738)">{{
              $t('message.confirmSubmitToAdministration') }}</el-button>
          </span>
          <!-- 导出 -->
          <!-- <el-button type="primary" class="btn-blue" v-if="['2', '5'].includes(activeTab)">{{ $t('message.excelExport')
          }}</el-button> -->
          <span v-if="['2'].includes(activeTab)">
            <!-- 取消转库 -->
            <el-button type="primary" class="btn-dark" @click="transferCancel" v-if="isAuth(736)">{{
              $t('message.cancelTransfer')
            }}</el-button>
            <!-- 上架到长存仓库 -->
            <el-button type="primary" class="btn-blue" @click="openShelfToCharge" v-if="isAuth(739)">{{
              $t('message.uploadToLongTermStorageWarehouse') }}</el-button>
          </span>
          <span v-if="['5'].includes(activeTab)">
            <!-- 取消出库申请 -->
            <el-button type="primary" class="btn-dark" @click="cancelOutbound" v-if="isAuth(737)">{{
              $t('message.cancelOutboundApplication') }}</el-button>
            <!-- 取出到配货 -->
            <el-button type="primary" class="btn-blue" @click="openTakeOutForPick" v-if="isAuth(740)">{{
              $t('message.takeOutToDistribution') }}</el-button>
          </span>
          <!-- 上架到常规商品仓库 -->
          <el-button type="primary" class="btn-blue" v-if="['4'].includes(activeTab) && isAuth(741)"
            @click="openShelfToNormal">{{
              $t('message.uploadToRegularWarehouse') }}</el-button>
        </div>
      </div>
    </div>

    <!-- 箱子列表 -->
    <div class="table-wrap">
      <div class="box-table">
        <div class="table-row header-row">
          <!-- 表头字段 -->
          <div class="cell checkbox-cell">
            <el-checkbox v-model="checked" :indeterminate="isIndeterminate" />
          </div>
          <div class="cell no-cell">NO</div>
          <!-- 客户对应人 -->
          <div class="cell admin-cell">{{ $t('message.customerCorrespondingPerson') }}</div>
          <!-- 客户信息 -->
          <div class="cell user-cell">{{ $t('message.userInfo') }}</div>
          <!-- 箱号 -->
          <div class="cell box-cell">{{ $t('message.boxNums') }}</div>
          <!-- 装箱完成时间 -->
          <div class="cell time-cell" v-if="['1', '2'].includes(activeTab)">{{ $t('message.packCompleteTime') }}</div>
          <!-- 提出转库时间 -->
          <div class="cell time-cell" v-if="['1', '2'].includes(activeTab)">{{ $t('message.proposeTransferTime') }}
          </div>
          <!-- 箱内SKU数 -->
          <div class="cell sku-cell">{{ $t('message.boxInnerSKUNum') }}</div>
          <!-- 箱内商品数 -->
          <div class="cell goods-cell">{{ $t('message.boxInnerGoodsNum') }}</div>
          <!-- 实际重量 -->
          <div class="cell weight-cell">{{ $t('message.actualWeight') }}</div>
          <!-- 箱子尺寸 -->
          <div class="cell size-cell">{{ $t('message.boxSize') }}(cm)</div>
          <!-- 箱内商品价值.元 -->
          <div class="cell amount-cell">{{ $t('message.boxInnerGoodsValue') }}</div>
          <!-- 提出转库人 -->
          <div class="cell transfer-apply-by-cell" v-if="['1'].includes(activeTab)">{{ $t('message.transferApplyBy') }}
          </div>

          <!-- 库位 -->
          <div class="cell location-cell" v-if="['5'].includes(activeTab)">{{ $t('message.location') }}</div>
          <!-- 出库提出人 -->
          <div class="cell transfer-apply-by-cell" v-if="['5'].includes(activeTab)">{{ $t('message.outOfShelfApplyBy')
          }}
          </div>
          <!-- 提出出库时间 -->
          <div class="cell  multiline time-cell" v-if="['5'].includes(activeTab)">{{ $t('message.outOfShelfApplyTime')
          }}
          </div>
          <!-- 入库时间 -->
          <div class="cell time-cell" v-if="['5'].includes(activeTab)">{{ $t('message.timeOfStorage') }}<br>({{
            $t('message.longTermStorageWarehouse') }})</div>
          <!-- 库龄（已保管天数） -->
          <div class="cell age-cell" v-if="['5'].includes(activeTab)">{{ $t('message.warehouseAgeTitle') }}<br>({{
            $t('message.storedDays') }})</div>
          <!-- 配货箱子备注 -->
          <div class="cell distribution-box-remark-cell">{{
            $t('message.distributionBoxRemark') }}</div>
          <!-- 业务箱子备注 -->
          <div class="cell business-box-remark-cell">{{
            $t('message.businessBoxRemark') }}</div>
          <!-- 行政取出时间 -->
          <div class="cell time-cell" v-if="['4'].includes(activeTab)">{{ $t('message.administrativeExtractionTime') }}
          </div>
        </div>

        <div v-if="!tableData.length" class="empty-placeholder">
          暂无数据
        </div>

        <div v-for="(item, index) in tableData" :key="item.id">
          <!-- 箱子基础信息行 -->
          <div class="table-row box-row">
            <div class="cell checkbox-cell">
              <el-checkbox v-model="item.checked" @change="changeItem" />
            </div>
            <div class="cell no-cell">{{ getRowNo(index) }}</div>
            <!-- 客户对应人员 -->
            <div class="cell admin-cell multiline">
              {{ $t('message.business') }}:{{ item.order.y_admin.realname }}<br>
              {{ $t('message.purchase') }}:{{ item.order.g_admin.realname }}<br>
              {{ $t('message.distribution') }}:{{ item.order.p_admin.realname }}
            </div>
            <!-- 客户信息 -->
            <div class="cell user-cell multiline">
              ID：{{ item.order.user.id }}<br>
              {{ item.order.user.realname }}
            </div>
            <!-- 箱号及展开按钮 -->
            <div class="cell box-cell">
              <router-link class="box-no" :to="`/boxDetail?id=${item.id
                }&verification=${$md5(item.id + '')}`" target="_blank">BOX-{{ item.box_sn }}</router-link>
              <button class="expand-btn" @click="toggleRow(item)">
                {{ item.show ? $t('message.collapse') : $t('message.expand') }}
                <i class="small-arrow" :class="{ up: item.show }"></i>
              </button>
            </div>
            <!-- 装箱完成时间 -->
            <div v-if="['1', '2'].includes(activeTab)" class="cell time-cell multiline">
              <template v-if="item.complete_at">
                {{ splitDateTime(item.complete_at).date }}<br>
                {{ splitDateTime(item.complete_at).time }}
              </template>
              <template v-else>-</template>
            </div>
            <!-- 提出转库时间 -->
            <div v-if="['1', '2'].includes(activeTab)" class="cell time-cell multiline">
              <template v-if="item.transfer_apply_at">
                {{ splitDateTime(item.transfer_apply_at).date }}<br>
                {{ splitDateTime(item.transfer_apply_at).time }}
              </template>
              <template v-else>-</template>
            </div>
            <div class="cell sku-cell">{{ item.sku_count }}</div>
            <div class="cell goods-cell">{{ item.goods_count }}</div>
            <div class="cell weight-cell">{{ item.weight }}</div>
            <div class="cell size-cell">{{ formatBoxSize(item) }}</div>
            <div class="cell amount-cell">{{ item.goods_value }}</div>
            <!-- 提出转库人 -->
            <div v-if="['1'].includes(activeTab)" class="cell transfer-apply-by-cell">{{ item.transfer_apply_by_name ||
              '-' }}</div>

            <!-- 库位 -->
            <div v-if="['5'].includes(activeTab)" class="cell location-cell location-text">
              <span v-if="item.warehouse_name">{{ item.warehouse_name }}</span>
              <span v-else>{{ $t('message.longTermStorageWarehouse') }}</span><br>
              {{ item.grid_number || '-' }}
            </div>
            <!-- 出库提出人 -->
            <div class="cell transfer-apply-by-cell" v-if="['5'].includes(activeTab)">{{
              item.transfer_return_apply_by_name
            }}
            </div>
            <!-- 提出出库时间 -->
            <div class="cell  multiline time-cell" v-if="['5'].includes(activeTab)">{{ item.transfer_return_apply_at }}
            </div>
            <!-- 入库时间 -->
            <div v-if="['5'].includes(activeTab)" class="cell time-cell multiline">
              <template v-if="item.transfer_charge_wms_at">
                {{ splitDateTime(item.transfer_charge_wms_at).date }}<br>
                {{ splitDateTime(item.transfer_charge_wms_at).time }}
              </template>
              <template v-else>-</template>
            </div>
            <div v-if="['5'].includes(activeTab)" class="cell age-cell">{{ item.storage_days != null ? item.storage_days
              : '-' }}
            </div>
            <!-- 配货箱子备注 -->
            <div class="cell distribution-box-remark-cell">
              <el-input type="textarea" v-model="item.p_remark" @blur="updateBoxRemark(item, 'p')"
                :disabled="remarkData.remark_type != 5" :placeholder="$t('message.distributionBoxRemark')" />
            </div>
            <!-- 业务箱子备注 -->
            <div class="cell business-box-remark-cell">
              <el-input type="textarea" v-model="item.y_remark" @blur="updateBoxRemark(item, 'y')"
                :disabled="remarkData.remark_type != 1" :placeholder="$t('message.businessBoxRemark')" />
            </div>
            <!-- 行政取出时间 -->
            <div v-if="['4'].includes(activeTab)" class="cell time-cell multiline">
              <template v-if="item.transfer_out_at">
                {{ splitDateTime(item.transfer_out_at).date }}<br>
                {{ splitDateTime(item.transfer_out_at).time }}
              </template>
              <template v-else>-</template>
            </div>
          </div>

          <div v-if="item.show" class="goods-detail">
            <!-- 箱内商品明细 -->
            <div class="goods-row goods-header">
              <div class="goods-cell order">{{ $t('message.orderNumberMash') }}</div>
              <div class="goods-cell sort">{{ $t('message.mash') }}</div>
              <div class="goods-cell attr">{{ $t('message.commodityAttribute') }}</div>
              <div class="goods-cell img">{{ $t('message.picture') }}</div>
              <div class="goods-cell num">{{ $t('message.quantity') }}</div>
            </div>
            <div v-for="(order, orderIndex) in item.order_detail_list" :key="orderIndex" class="goods-row">
              <div class="goods-cell order">
                <router-link v-if="order.order_sn" :to="`/orderPaymentDetail?order_sn=${order.order_sn}`"
                  target="_blank" class="box-no">
                  {{ order.order_sn }}
                </router-link>
                <span v-else>-</span>
              </div>
              <div class="goods-cell sort">{{ order.sorting }}</div>
              <div class="goods-cell attr">
                <p v-for="(attr, attrIndex) in order.detail_y" :key="attrIndex">
                  {{ attr.key }}:{{ attr.value }}
                </p>
                <span v-if="!order.detail_y || !order.detail_y.length">-</span>
              </div>
              <div class="goods-cell img">
                <el-popover v-if="order.pic" placement="right" width="300" trigger="hover">
                  <el-image :src="order.pic" style="width: 300px; height: 300px;" />
                  <a v-if="order.link && order.link.goods_url" :href="order.link.goods_url" target="_blank"
                    rel="noopener" slot="reference">
                    <el-image :src="order.pic" fit="fill" style="width: 60px; height: 60px;" />
                  </a>
                  <el-image v-else slot="reference" :src="order.pic" fit="fill" style="width: 60px; height: 60px;" />
                </el-popover>
                <div v-else class="goods-img"></div>
              </div>
              <div class="goods-cell num">{{ order.num }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[50, 100, 200, 400, 500, 1000]" :page-size="datas.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <shelfToCharge ref="shelfToCharge" @success="handleShelfToChargeSuccess" />
    <warehouse v-if="warehouseDialogVisible" :shelf_type_set="normalWarehouseShelfTypes" :type="13" />
  </div>
</template>

<script>
import shelfToCharge from './components/shelfToCharge.vue'
import warehouse from '@/components/common/warehouse.vue'

export default {
  name: 'TransferBox',
  components: {
    shelfToCharge,
    warehouse
  },
  computed: {
    y() {
      return this.$store.state.authWorkGroupAdmin.y
    },
    g() {
      return this.$store.state.authWorkGroupAdmin.g
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p
    }
  },
  data() {
    return {
      // 搜索条件
      datas: {
        user_id: '', // 客户ID
        purchase_no: '', // 物流号
        express_no: '', // 交易号
        order_sn: '', // 订单号
        y_id: '', // 业务员ID
        g_id: '', // 采购员ID
        p_id: '', // 配货员ID
        pack_date_start: '', // 提出转库开始时间
        pack_date_end: '', // 提出转库结束时间
        age_min: '', // 库龄最小值
        age_max: '', // 库龄最大值
        page: 1, // 页码
        pageSize: 50 // 每页条数
      },
      total: 0, // 列表总数
      activeTab: '1', // 当前Tab
      // 转库箱子状态Tab：transfer_status 1待配货确认 2等待放入长存 3长存待取出 4待配货上架
      tabs: [
        { value: 'pending_confirm', labelKey: 'pendingDistributionConfirm', count: 0, status: '1' },
        { value: 'pending_charge', labelKey: 'waitPutIntoLongTermStorageWarehouse', count: 0, status: '2' },
        { value: 'pending_out_pick', labelKey: 'waitTakeOutFromLongTermStorageWarehouse', count: 0, status: '5' },
        { value: 'pending_shelf', labelKey: 'pendingDistributionShelf', count: 0, status: '4' }
      ],
      checked: false,
      isIndeterminate: false,
      syncingChecked: false,
      warehouseDialogVisible: false,
      normalWarehouseShelfTypes: [1],
      tableData: [], // 箱子列表
      selectList: [],
      boxIds: [],
      // 箱子备注编辑权限：5 配货备注，1 业务备注
      remarkData: {
        remark_type: localStorage.getItem("japanUserRoleStatus")
      }
    }
  },
  watch: {
    // 表头全选状态同步到当前页列表
    checked(val) {
      if (this.syncingChecked) return
      this.tableData.forEach(item => {
        item.checked = val
      })
      this.isIndeterminate = false
      this.changeItem()
    }
  },
  created() {
    this.boxTransferTabCount()
    this.boxTransferList()
  },
  methods: {
    /*
     * 列表列与接口字段对应：
     * 客户对应人 y_admin_name / g_admin_name / p_admin_name（或 wms_move.user.*_admin）
     * 客户信息 user_id、user_name
     * 箱号 box_sn | SKU数 sku_count | 商品数 goods_count | 重量 weight | 尺寸 c、k、g | 价值 goods_value
     * 提出转库人 transfer_apply_by_name | 装箱操作人 pack_by_name / pack_by_admin.realname
     * 库位 warehouse_name、grid_number | 入库时间 complete_at_display | 库龄 storage_days
     * 配货备注 p_box_remark | 业务备注 y_box_remark | 行政取出 admin_take_out_at_display
     * 展开明细 order_detail_list：order_sn、sorting、detail_y、pic、link、num
     * 查询：transfer_status(Tab)、user_id、order_sn、y_id、g_id、p_id、dateStart/dateEnd(提出转库)
     */
    // 转库箱子tab数量统计
    boxTransferTabCount() {
      this.$api.inventoryTransferApi.boxTransferTabCount().then(res => {
        this.tabs.forEach(tab => {
          tab.count = res.data[tab.value]
        })
      })


    },
    // 转库箱子列表
    boxTransferList() {
      // 按接口字段组装查询参数
      const params = {
        transfer_status: Number(this.activeTab) || 1,
        page: this.datas.page,
        pageSize: this.datas.pageSize
      }
      if (this.datas.user_id !== '' && this.datas.user_id != null) params.user_id = this.datas.user_id
      if (this.datas.order_sn) params.order_sn = this.datas.order_sn
      if (this.datas.y_id) params.y_id = this.datas.y_id
      if (this.datas.g_id) params.g_id = this.datas.g_id
      if (this.datas.p_id) params.p_id = this.datas.p_id
      if (this.datas.pack_date_start) params.dateStart = this.datas.pack_date_start
      if (this.datas.pack_date_end) params.dateEnd = this.datas.pack_date_end
      this.$api.inventoryTransferApi.boxTransferList(params).then(res => {
        this.setTableData(res.data)
      })


    },
    // 设置列表数据
    setTableData(data) {
      const list = data.data || []
      list.forEach(item => {
        item.show = false
        item.checked = false
      })
      this.tableData = list
      this.total = data.total || 0
      this.checked = false
      this.isIndeterminate = false
      this.selectList = []
      this.boxIds = []
    },
    // 计算分页序号
    getRowNo(index) {
      return (this.datas.page - 1) * this.datas.pageSize + index + 1
    },
    // 格式化箱子尺寸 c*k*g
    formatBoxSize(item) {
      if (item.c == null && item.k == null && item.g == null) return '-'
      return `${item.c || 0}*${item.k || 0}*${item.g || 0}`
    },
    // 拆分日期时间显示
    splitDateTime(datetime) {
      if (!datetime) return { date: '', time: '' }
      const [date, time] = datetime.split(' ')
      return { date: date || '', time: time || '' }
    },



    // 切换Tab
    handleTabChange() {
      this.datas.page = 1
      this.boxTransferList()
    },
    // 根据国际化 key 获取文案
    getMessage(key) {
      return this.$t(`message.${key}`)
    },
    // 拼接页签名称和数量
    getTabLabel(tab) {
      return `${this.getMessage(tab.labelKey)}(${tab.count})`
    },
    // 搜索列表
    handleSearch(resetPage = true) {
      if (resetPage) {
        this.datas.page = 1
      }
      this.boxTransferList()
    },
    // 切换当前页
    handleCurrentChange(val) {

      this.datas.page = val
      this.handleSearch(false)
    },
    // 切换每页条数
    handleSizeChange(val) {
      this.datas.pageSize = val
      this.datas.page = 1
      this.handleSearch()
    },
    // 重置搜索条件
    reset() {
      this.datas = {
        user_id: '',
        purchase_no: '',
        express_no: '',
        order_sn: '',
        y_id: '',
        g_id: '',
        p_id: '',
        pack_date_start: '',
        pack_date_end: '',
        age_min: '',
        age_max: '',
        page: 1,
        pageSize: 50
      }
      this.handleSearch()
    },
    // 展开/收起箱内商品明细
    toggleRow(item) {
      item.show = !item.show
    },
    // 同步当前选中的箱子
    changeItem() {
      this.selectList = this.tableData.filter(item => item.checked)
      this.boxIds = this.selectList.map(item => item.box_id || item.id)
      const selectedCount = this.selectList.length
      const totalCount = this.tableData.length
      const allChecked = totalCount > 0 && selectedCount === totalCount
      this.isIndeterminate = selectedCount > 0 && selectedCount < totalCount
      if (this.checked !== allChecked) {
        this.syncingChecked = true
        this.checked = allChecked
        this.$nextTick(() => {
          this.syncingChecked = false
        })
      }
    },
    // 校验是否已选择可操作箱子
    validateSelected() {
      if (!this.selectList.length) {
        this.$message.error(this.$t("message.selectableOperational"))
        return false
      }
      return true
    },
    // 取消转库
    transferCancel() {
      if (!this.validateSelected()) return
      this.$confirm(
        '确认取消转库吗？',
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.$api.inventoryTransferApi.transferCancel({ boxIds: this.boxIds }).then(res => {
            this.$message.success(res.msg)
            this.boxTransferTabCount()
            this.boxTransferList()
          })
        })
        .catch(() => { })
    },
    // 确认提交给行政
    confirmToAdmin() {
      if (!this.validateSelected()) return
      this.$confirm(
        '确认提交给行政吗？',
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.$api.inventoryTransferApi.confirmToAdmin({ boxIds: this.boxIds }).then(res => {
            this.$message.success(res.msg)
            this.boxTransferTabCount()
            this.boxTransferList()
          })
        })
        .catch(() => { })
    },
    // 打开上架到长存仓库弹框
    openShelfToCharge() {
      if (!this.validateSelected()) return
      this.$refs.shelfToCharge.init(this.boxIds, {
        title: '上架到长存仓库',
        apiName: 'shelfToCharge',
        shelfTypes: [4]
      })
    },
    // 上架到长存仓库成功后刷新列表
    handleShelfToChargeSuccess() {
      this.boxTransferTabCount()
      this.boxTransferList()
    },
    // 取出给配货
    openTakeOutForPick() {
      if (!this.validateSelected()) return
      this.$refs.shelfToCharge.init(this.boxIds, {
        title: '取出给配货',
        apiName: 'takeOutForPick',
        needWarehouse: false
      })
    },
    // 打开普通仓库库位选择，选中后提交上架到常规商品仓库
    openShelfToNormal() {
      if (!this.validateSelected()) return
      this.warehouseDialogVisible = true
    },
    // 仓库组件回传库位号后，调用常规商品仓库上架接口
    selectChargeGridNumber(gridNumber) {
      if (!gridNumber) {
        this.$message.error('请选择普通仓库库位')
        return
      }
      this.$api.inventoryTransferApi.shelfToNormal({
        grid_number: gridNumber,
        boxIds: this.boxIds
      }).then(res => {
        this.$message.success(res.msg)
        this.warehouseDialogVisible = false
        this.boxTransferTabCount()
        this.boxTransferList()
      })
    },
    // 取消出库申请
    cancelOutbound() {
      if (!this.validateSelected()) return
      this.$confirm(
        '确认取消出库申请吗？',
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.$api.inventoryTransferApi.cancelOutbound({ boxIds: this.boxIds }).then(res => {
            this.$message.success(res.msg)
            this.boxTransferTabCount()
            this.boxTransferList()
          })
        })
        .catch(() => { })
    },
    // 箱子备注失焦保存：配货备注 p_box_remark，业务备注 y_box_remark
    updateBoxRemark(item, type) {
      const params = {
        box_id: item.box_id || item.id
      }
      if (type === 'p') {
        params.p_remark = item.p_box_remark
        this.$api.inspectionApi.updatePRemark(params)
      } else {
        params.y_remark = item.y_box_remark
        this.$api.inspectionApi.updateYRemark(params)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.transfer-box-page {
  /* token Background/colorBgContainer paint_154:7424 #FFFFFF */
  /* token 颜色/主色 paint_79:0570 #B4272D */
  /* token 颜色/线条 paint_79:0586 #DCDFE6 */
  /* token 颜色/背景F8 paint_79:0590 #F8F8F8 */
  /* token 颜色/背景F6 paint_79:0596 #F6F6F6 */
  /* token 文字/正文333 paint_79:0600 #333333 */
  /* token 文字/次要666 paint_79:0606 #666666 */
  /* token 文字/辅助999 paint_79:0612 #999999 */
  /* token 颜色/蓝色 paint_79:2000 #2C96E7 */
  min-height: 100%;
  padding: 24px;
  box-sizing: border-box;
  background: #f8f8f8;
  color: #333;
  font-family: "Source Han Sans SC", "Microsoft YaHei", Arial, sans-serif;
  font-size: 14px;
}

.tabs {
  margin-bottom: 20px;
  width: 100%;
}

.search-area {
  width: 100%;
  margin-bottom: 20px;

  .search-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 20px;

    &.second {
      margin-top: 20px;
    }
  }

  .item {
    flex: 0 0 200px;
    max-width: 100%;

    .el-input,
    .el-select,
    .el-date-editor {
      width: 100%;
    }
  }
}

.small-arrow {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-left: 6px;
  border-right: 1px solid #909399;
  border-bottom: 1px solid #909399;
  transform: rotate(45deg);

  &.up {
    margin-top: 4px;
    transform: rotate(225deg);
  }
}

.search-buttons {
  display: flex;
  gap: 10px;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  flex: 1;
  gap: 10px;

  .btn-blue {
    border-color: #2c96e7;
    background: #2c96e7;
  }

  .btn-dark {
    border-color: #333;
    background: #333;
  }
}

.table-wrap {
  width: 100%;
  border-radius: 4px;

}

.paginationContainer {
  margin-top: 20px;
}

.box-table {
  width: 100%;
  position: relative;
  background: #fff;
}

.empty-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  border-bottom: 1px solid #dcdfe6;
  color: #909399;
  background: #fff;
}

.table-row {
  display: flex;
  align-items: center;
  min-height: 138px;
  padding: 20px 0;
  border-bottom: 1px solid #dcdfe6;
  box-sizing: border-box;
}

.header-row {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 3;
  min-height: 56px;
  padding: 0;
  background: #edeff4;
  color: #666;
  font-weight: 700;
  line-height: 18px;

}

.cell {
  flex: 1;
  box-sizing: border-box;
  padding: 0 6px;
  text-align: center;
  line-height: 20px;
  word-break: break-all;
  min-width: 0;
}

.checkbox-cell {
  flex: 0 0 52px;
  padding: 0 12px;
}

.no-cell {
  flex: 0 0 60px;
}

.admin-cell {
  flex: 1 1 100px;
  min-width: 90px;
}

.user-cell {
  flex: 1 1 100px;
  min-width: 90px;
}

.box-cell {
  flex: 1.2 1 140px;
  min-width: 120px;
  text-align: left;
}

.sku-cell,
.goods-cell {
  flex: 0.8 1 80px;
  min-width: 70px;
}

.weight-cell,
.size-cell {
  flex: 1 1 90px;
  min-width: 80px;
}

.amount-cell {
  flex: 1 1 100px;
  min-width: 90px;
}

.transfer-apply-by-cell,
.pack-by-cell {
  flex: 1 1 90px;
  min-width: 80px;
}

.location-cell {
  flex: 1.2 1 120px;
  min-width: 100px;
}

.time-cell {
  flex: 0 0 110px;
  min-width: 110px;
  max-width: 110px;
}

.age-cell {
  flex: 0.8 1 80px;
  min-width: 70px;
}

.distribution-box-remark-cell,
.business-box-remark-cell {
  flex: 1 1 100px;
  min-width: 90px;
}

.checkbox {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
}

.multiline {
  text-align: left;
  line-height: 22px;
}

.box-no {
  display: block;
  color: #b4272d;
  text-decoration: underline;
  line-height: 20px;
  cursor: pointer;
}

.expand-btn {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 60px;
  height: 24px;
  margin-top: 7px;
  padding: 0 6px;
  border: 0;
  border-radius: 4px;
  color: #999;
  background: #f6f6f6;
  font-size: 12px;
  cursor: pointer;
}

.location-text {
  line-height: 20px;

  span {
    color: #b4272d;
  }
}

.goods-detail {
  width: 100%;
}

.goods-row {
  display: flex;
  align-items: center;
  min-height: 84px;
  padding: 12px 60px;
  border-bottom: 1px solid #dcdfe6;
  background: #fff;
  box-sizing: border-box;

  &.goods-header {
    min-height: 56px;
    padding: 0 60px;
    background: #dcdfe6;
    color: #666;
    font-weight: 700;
  }
}

.goods-cell {

  text-align: center;
  line-height: 22px;
  min-width: 0;
  word-break: break-all;

  &.order {
    flex: 2;
    min-width: 150px;
  }

  &.sort {
    flex: 0.5;
    min-width: 60px;
  }

  &.attr {
    flex: 2;
    min-width: 150px;
  }

  &.img {
    flex: 0.8;
    min-width: 80px;
  }

  &.num {
    flex: 0.5;
    min-width: 60px;
  }
}

.goods-img {
  width: 60px;
  height: 60px;
  margin: 0 auto;
  background: #d8d8d8;
}

/deep/.el-textarea__inner {
  padding: 3px;
  height: 100px !important;
  font-size: 14px;
}
</style>
